import type { PropsWithChildren, ReactNode } from 'react';

type ConditionGuardProps = PropsWithChildren<{
  condition: boolean;
  fallback?: ReactNode;
}>;

export const ConditionGuard = ({ condition, fallback, children }: ConditionGuardProps) => {
  if (condition) return children;
  if (fallback) return fallback;
  return <></>;
};
